import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomerService} from '../../services/customer.service';
import {OrderService} from '../../services/order.service';
import {ActivationEnd, NavigationStart, Router} from '@angular/router';
import * as _ from 'lodash';
import {CookieService} from 'ngx-cookie-service';
import {SharedService} from '../../services/shared.service';
import {MatDialog, MatDialogConfig} from '@angular/material';
import * as moment from 'moment';
import {RateDialogComponent} from '../../components/rate-dialog/rate-dialog.component';
import {first, takeUntil} from 'rxjs/operators';
import {ExpiredDialogComponent} from '../../components/expired-dialog/expired-dialog.component';
import {Subject} from 'rxjs';
import * as firebase from 'firebase/app';
import 'firebase/messaging';
import {UUID} from 'angular2-uuid';
import {RescheduleDialogComponent} from '../../components/reschedule-dialog/reschedule-dialog.component';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  params: any = {};
  dialogOpen: boolean;
  private messaging;
  private showDialog: boolean = true;

  constructor(private customerService: CustomerService,
              private orderService: OrderService,
              private router: Router,
              private cookieService: CookieService,
              private shared: SharedService,
              private dialog: MatDialog) {
    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        //Don't show reschedule dialog on payment, results & order details
        let url = this.router.url;
        this.showDialog = url.indexOf('request/payment') == -1 && url.indexOf('request/results') == -1 && url.indexOf('orders/details/') == -1;

        if (event instanceof NavigationStart) {
          this.params = {};
        }
        if (event instanceof ActivationEnd) {
          this.params = _.merge(this.params, event.snapshot.params);
        }
      });
    if (firebase.messaging.isSupported()) this.messaging = firebase.messaging(); //If browsers support push notifications
    if (this.messaging) {
      this.messaging.onMessage(payload => {
        let options = payload['notification'];
        if ('Notification' in window) {
          let n = new Notification(options.title, options);
        }
      });
    }

    this.customerService.authChanged()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(customer => {
        if (customer) {
          this.orderChecker();
          if (this.messaging) {//If browser support notification
            //Notification access request
            this.getNotificationToken(customer);
            this.messaging.onTokenRefresh(() => {
              this.getNotificationToken(customer);
            });
          }
        }
      });
  }

  ngOnInit() {
    //Check current user for stripe account
    this.customerService.getCurrentCustomer(true)
      .then(customer => {
        //If customer doesn't have stripe account - create one
        if (customer && !customer.stpID) {
          return this.customerService.createStripeAccountForCurrentCustomer();
        }
      });


  }

  orderChecker() {
    this.customerService.getCurrentCustomer()
      .then(customer => {
        if (customer) {
          this.orderService.getCustomersOrders(customer.uid)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(orders => {
              if (orders.length) {
                let yesterday = new Date().getTime() - 1000 * 60 * 60 * 24;
                let showedDialog = this.cookieService.get('w_cOrder');
                orders = _.orderBy(orders, ['date'], ['desc']);
                let lastOrder = orders[0]; //Last placed order
                //Dialog configuration
                const dialogConfig = new MatDialogConfig();
                dialogConfig.autoFocus = true;
                dialogConfig.disableClose = true;
                let dialogComponent;
                let dialogType;
                //If last order expired or was rejected
                if ((lastOrder.status == 7 || lastOrder.status == 8) && lastOrder.deliveryDate > yesterday && showedDialog != lastOrder.id) {
                  dialogConfig.data = {order: lastOrder};//Pass order to dialog
                  dialogComponent = ExpiredDialogComponent;
                  dialogType = 'reject';
                }
                //Check for reschedule orders
                _.forEach(orders, (order, i) => {
                  if (order.status == 9 && !dialogComponent) {
                    dialogConfig.data = {order: order};//Pass order to dialog
                    dialogComponent = RescheduleDialogComponent;
                    dialogType = 'reschedule';
                  }
                });
                //Check for orders to rate
                _.forEach(orders, (order, i) => {
                  if (order.status == 5 && !order.rating && !dialogComponent && !this.shared.getRateLater()) {
                    dialogConfig.data = {
                      order: order,
                      title: 'RATING.LASTTITLE',
                      messageText: moment(order.date).format('LL'),
                      rateText: 'RATING.LASTRATE'
                    };
                    dialogComponent = RateDialogComponent;
                    dialogType = 'rate';
                  }
                });
                if (this.showDialog && !this.dialogOpen && dialogComponent) {
                  let dRef = this.dialog.open(dialogComponent, dialogConfig);
                  this.dialogOpen = true;
                  dRef.afterClosed().pipe(first()).toPromise()
                    .then(() => {
                      this.dialogOpen = false;
                      if (dialogType == 'reject') this.cookieService.set('w_cOrder', lastOrder.id, new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 2), '/');
                    });
                }
              }
            });
        }
      });
  }

  private getNotificationToken(customer) {
    this.messaging.getToken()
      .then(token => {
        if (!token) {
          this.messaging.requestPermission()
            .then(res => {
              this.getNotificationToken(customer);
            });
        } else {
          let alreadyUpdated = false;//If fcm is already in database
          // console.log(token);
          // console.log(window.navigator);
          let devices = customer.devices || {}; //Get customer devices
          Object.getOwnPropertyNames(devices) //Check if fcm token is already in database
            .map(key => {
              if (devices[key]['fcm'] == token) alreadyUpdated = true;
            });
          if (!alreadyUpdated) { //If fcm token is not in database, store it
            let uuid = UUID.UUID().toUpperCase();
            devices[uuid] = {
              Os: 'Browser',
              fcm: token,
              UUID: uuid
            };
            this.customerService.updateCustomerProfile({devices: devices});
          }
        }
      })
      .catch(console.log);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


}
